var $class="se2--roi-calculator-widget",$name="roiCalculatorWidget",$path="app/partials/roiCalculatorWidget/config.js",$this={$class,$name,$path,};export const popupTriggerId = '61934bbd0635340c526239af';
export const popupTriggerScriptUrl = 'https://dyv6f9ner1ir9.cloudfront.net/assets/js/nploader.js';
